import { Routes } from '@angular/router';

/**
 * Rotas da feature CRM (funil de oportunidades) — CRM v1, issue frontend #122.
 * Importadas via spread dentro de `tenantFeatureRoutes` em `app.routes.ts`,
 * já protegidas por `authGuard` + `tenantGuard` no path pai `:tenantId`.
 */
export const crmRoutes: Routes = [
  {
    path: 'crm',
    pathMatch: 'full',
    redirectTo: 'crm/funil',
  },
  {
    path: 'crm/funil',
    loadComponent: () =>
      import('./funil/crm-funil.component').then(m => m.CrmFunilComponent),
    data: { breadcrumb: [{ label: 'CRM' }] },
  },
  {
    path: 'crm/oportunidade/:id',
    loadComponent: () =>
      import('./oportunidade-detalhe/oportunidade-detalhe.component').then(
        m => m.OportunidadeDetalheComponent
      ),
    data: { breadcrumb: [{ label: 'CRM', path: 'crm/funil' }, { label: 'Detalhe da oportunidade' }] },
  },
  {
    // ADR-012: "Configurações" deixou de ser 1 rota com abas (Estágios/Motivos
    // eram funcionalidades distintas, não seções de um registro) — cada uma
    // agora é rota própria. Redireciona para a primeira por compatibilidade
    // com quem ainda navega para 'crm/config' diretamente.
    path: 'crm/config',
    pathMatch: 'full',
    redirectTo: 'crm/config/estagios',
  },
  {
    path: 'crm/config/estagios',
    loadComponent: () =>
      import('./config-estagios/crm-config-estagios.component').then(
        m => m.CrmConfigEstagiosComponent
      ),
    data: { breadcrumb: [{ label: 'CRM', path: 'crm/funil' }, { label: 'Estágios do funil' }] },
  },
  {
    path: 'crm/config/motivos',
    loadComponent: () =>
      import('./config-motivos/crm-config-motivos.component').then(
        m => m.CrmConfigMotivosComponent
      ),
    data: { breadcrumb: [{ label: 'CRM', path: 'crm/funil' }, { label: 'Motivos de perda' }] },
  },
];
